// @flow

import React from 'react';
import imageReloadFactory from 'app/common/react/components/partner/helpers/imageReload';
import type { BasicImage } from 'app/packages/pinterest-flow-types/image';
import { GRID_ITEM_WIDTH } from 'app/common/lib/react/gridUtils';
import { Image, Box } from 'gestalt';

export type PinProps = {
  description: string,
  dominant_color: string,
  images: {
    '474x': BasicImage,
  },
};

type HeightProp = {| imgHeight?: number |};

type SquareProp = {| square?: boolean |};

type Props = {|
  pin: PinProps,
  containerWidth?: number,
  ...HeightProp | SquareProp,
|};

const DEFAULT_PLACEHOLDER_COLOR = '#efefef';
const RELOAD_RETRIES = 5;

const DisplayPinImage = (props: Props) => {
  const containerWidth =
    props.containerWidth === undefined ? GRID_ITEM_WIDTH : props.containerWidth;
  const square = props.square || false;
  const imgHeight = props.imgHeight || undefined;
  const { pin } = props;
  const pinImage = pin.images['474x'];

  if (!pin) {
    return null;
  }

  return (
    <Box
      shape="rounded"
      overflow="hidden"
      display="flex"
      direction="column"
      justifyContent="center"
      width={containerWidth}
      height={square ? GRID_ITEM_WIDTH : imgHeight}
    >
      <Image
        alt={pin.description}
        color={pin.dominant_color || DEFAULT_PLACEHOLDER_COLOR}
        naturalWidth={pinImage.width}
        naturalHeight={pinImage.height}
        onError={imageReloadFactory(pinImage.url, RELOAD_RETRIES)}
        src={pinImage.url}
        fit={imgHeight ? 'cover' : 'none'}
      />
    </Box>
  );
};

export default DisplayPinImage;
